import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/ServiceCategories";
import getToken from "app/api/getToken";
import { IServiceCategory } from "app/api/types";

export const DELETE_SERVICE_CATEGORY_REQUEST =
  "DELETE_SERVICE_CATEGORY_REQUEST";
export const DELETE_SERVICE_CATEGORY_SUCCESS =
  "DELETE_SERVICE_CATEGORY_SUCCESS";
export const DELETE_SERVICE_CATEGORY_FAIL = "DELETE_SERVICE_CATEGORY_FAIL";

export const delServiceCategory = (id: IServiceCategory["id"]) => (
  dispatch: any
): any => {
  dispatch({ type: DELETE_SERVICE_CATEGORY_REQUEST });

  const token = getToken();

  return api
    .delServiceCategory(token, id)
    .then((response: AxiosResponse) => {
      dispatch({ type: DELETE_SERVICE_CATEGORY_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: DELETE_SERVICE_CATEGORY_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
